import { Children, type ElementType } from "react";
import { useTypography, UseTypographyProps } from "./use-typography";
import { replaceWithMarkup } from "@/utils/text";

export type TypographyProps<C extends ElementType = "p"> =
  UseTypographyProps<C>;

export const Typography = <C extends ElementType = "p">(
  props: TypographyProps<C>
) => {
  const { styles, className, Component, children, secondColor, ref, ...rest } =
    useTypography(props);

  return (
    <Component ref={ref} className={styles.base({ className })} {...rest}>
      {Children.map(children, (child) => {
        if (
          typeof child === "string" &&
          (child.includes("|") || child.includes("**"))
        ) {
          return (
            <span
              dangerouslySetInnerHTML={{
                __html: replaceWithMarkup(child, secondColor),
              }}
            />
          );
        }

        return child;
      })}
    </Component>
  );
};
